import app from './app'
import categories from './categories'
import filters from './filters'

export default {
  app,
  categories,
  filters,
}
